/**
 * Портал для шторок: рендерит их в `document.body`.
 *
 * Без портала шторка живёт внутри `.app-main` (свой stacking context,
 * z-index: 1), и нижнее меню (z-index: 10) оказывается ПОВЕРХ неё —
 * кнопки внизу шторки перекрывались навигацией (баг заказчика 2026-08-21:
 * «стратегию не переключить» — кнопка подтверждения была под меню).
 */
import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';

export function SheetPortal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
